import DeprecatedDropdownContainer from 'components/Luxkit/Dropdown/DeprecatedDropdownContainer'
import ListItem from 'components/Luxkit/List/ListItem'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import React, { MouseEvent, useCallback, useEffect } from 'react'
import { BundleOfferPackageOptionView, getAvailableBundlePackages, getBundledPackages } from 'selectors/offerPage/offerPageSelectors'
import styled from 'styled-components'
import { takeCurrentOfferState, BundledOfferState } from 'contexts/OfferPage/offerPageStateReducer'
import { ALL_BUNDLES_LABEL } from 'constants/bundleAndSave'
import { isBundleAndSaveV2Enabled } from 'lib/offer/offerUtils'

const SizedDropdownContainer = styled(DeprecatedDropdownContainer)`
  max-height: 60vh;
`

interface Props {
  selectedPackageId?: string;
  onClose?: (e: MouseEvent<HTMLButtonElement>) => void;
  bundledOffers: {
    [offerId: string]: BundledOfferState
  }
  packageOptions: { [bundlePackageId: string]: BundleOfferPackageOptionView }
  bundledPackages: { [bundlePackageId: string]: App.Package[] }
}

function OfferCalendarBundlePackageDropdown(props: Props) {
  const { bundledPackages, packageOptions, selectedPackageId, bundledOffers, onClose } = props
  const dispatch = useOfferPageDispatch()

  const availableBundlePackagesKeys = Object.keys(bundledPackages).filter((bundlePackageId) => bundledPackages[bundlePackageId]?.length > 0)
  const selectedPackage = selectedPackageId ? packageOptions[selectedPackageId] : undefined
  const bundledOfferIds = Object.keys(bundledOffers)

  const onItemClick = useCallback((e: MouseEvent<HTMLButtonElement>) => {
    const packageId = e.currentTarget.dataset.id
    dispatch({ type: OfferPageActions.setFilteredBundlePackageId, filteredBundlePackageId: packageId })

    if (packageId) {
      if (packageOptions[packageId]) {
        for (const option of packageOptions[packageId].options) {
          dispatch({ type: OfferPageActions.setRoomType, room: option.package.roomType, offerId: option.package.offerId })
        }
      }
    } else {
      for (const bundledOfferId of bundledOfferIds) {
        dispatch({ type: OfferPageActions.setRoomType, room: undefined, offerId: bundledOfferId })
      }
    }

    onClose?.(e)
  }, [dispatch, onClose, packageOptions, bundledOfferIds])

  useEffect(() => {
    if (selectedPackageId && !selectedPackage) {
      dispatch({ type: OfferPageActions.setFilteredBundlePackageId, filteredBundlePackageId: undefined })

      for (const bundledOfferId of bundledOfferIds) {
        dispatch({ type: OfferPageActions.setRoomType, room: undefined, offerId: bundledOfferId })
      }
    }
  }, [dispatch, selectedPackage, bundledOfferIds, selectedPackageId])

  return (
    <SizedDropdownContainer
      title="Bundles"
      fit={isBundleAndSaveV2Enabled() ? 'dropdown-items' : undefined}
      onClose={onClose}>
      <ListItem
        title={ALL_BUNDLES_LABEL}
        selected={!selectedPackage}
        onClick={onItemClick}
      />
      {availableBundlePackagesKeys.map(bundlePackageId => <ListItem
        key={bundlePackageId}
        title={packageOptions[bundlePackageId].bundlePackageName}
        data-id={bundlePackageId}
        selected={bundlePackageId === selectedPackage?.bundlePackageId}
        onClick={onItemClick}
      />)}
    </SizedDropdownContainer>
  )
}

export default withOfferPageAndReduxState((currentState, reduxState) => {
  const state = takeCurrentOfferState(currentState)

  return {
    selectedPackageId: state.filteredBundlePackageId,
    packageOptions: getAvailableBundlePackages(currentState, reduxState),
    bundledPackages: getBundledPackages(state),
    bundledOffers: state.bundledOffers ?? {},
  }
})(OfferCalendarBundlePackageDropdown)
